import { isFlagEnabled, useCodeSparkFlags } from '../featureFlags';
import { useExperimentContext } from './context';
import { getEnabledVariant } from './utils';

/**
 * Hook for retrieving data for a particular variant for the component under a/b testing
 * @param {array} variants - list variants used for finding the active variant
 * (A section can have different data depending on which test is active)
 * @param {string} getDataFn - the function to use to return the variant data
 * (Usually use generateVariantData to create a mapping of variant and their data)
 * @returns {object}
 */
export const useExperimentVariantData = (variants, getDataFn) => {
  const { experiments } = useExperimentContext();
  const enabledVariant = getEnabledVariant(experiments, variants);

  return getDataFn(enabledVariant);
};

/**
 * Hook for bridging the gap between the new unleash feature flags and the older experiment flags
 * created for opty until refactoring can be done to clean up the old experiment wrappers.
 * Returns the first enabled feature flag or experiment
 * @param {array} variants - list variants used for finding the active variant
 * (A section can have different data depending on which test is active)
 * @param {string} getDataFn - the function to use to return the variant data
 * (Usually use generateVariantData to create a mapping of variant and their data)
 * @returns {object}
 */
export function useExperimentOrFeatureFlagData(variants, getDataFn) {
  const { experiments } = useExperimentContext();
  const featureFlags = useCodeSparkFlags(variants);

  const enabledVariant = variants.find(variant => {
    const featureFlag = featureFlags.find(({ name }) => name === variant);
    if (featureFlag && featureFlag.enabled) {
      return variant;
    }

    if (experiments[variant]) {
      return variant;
    }
  });

  return getDataFn(enabledVariant);
}



// WEBPACK FOOTER //
// ./src/experiments/hooks.js